import React from "react";
import * as S from "../styled";
import PT from "prop-types";
import Info from "_c/atoms/Info";
import isempty from "lodash/isEmpty";
import { SALOON_NS as ns } from "@/i18n/ns";
import Gallery from "./Gallery";
import { Link } from "react-router-dom";

const InteriorPhotos = ({ t, ...props }) => {
  return (
    <S.ListSect>
      <S.Title>{t(`${ns}:aside.interior_head`)}</S.Title>
      {isempty(props.photos) ? (
        <Info>
          {props.isOwner ? (
            <>
              <Link to="/salon/dashboard/interior">
                {t(`${ns}:aside.interior_set_link.1`)}
              </Link>{" "}
              <span>{t(`${ns}:aside.interior_set_link.2`)}</span>
            </>
          ) : (
            <div>{t(`${ns}:aside.interior_empty`)}</div>
          )}
        </Info>
      ) : (
        <Gallery defaultAltText={props.defaultAltText} photos={props.photos} />
      )}
    </S.ListSect>
  );
};
InteriorPhotos.props = {
  photos: PT.array,
  isOwner: PT.bool,
  defaultAltText: PT.string,

  t: PT.func.isRequired,
};

export default InteriorPhotos;
